import React, { useEffect, useState } from "react";

import ProjectsLayout, {
	Footer,
} from "../src/components/layouts/ProjectsLayout";
import { useProjectsList } from "../src/contexts/ProjectsListContext";
import { ProjectsSection } from "../src/components/sections/home";
import { CLoader } from "../src/components/_reusables/CLoader";
import SEO from "../src/components/layouts/SEO";
import profileProjectServices from "../src/services/profileProjectServices";

/* This Website contains all of my projects, organized in an order I want it to be */

const IndexPage = () => {
	const { fetchProjects, setFilterData } = useProjectsList();
	const [dataFetched, setDataFetched] = useState(false);

	useEffect(() => {
		fetchPosts();
	}, []);

	async function fetchPosts() {
		const res = await profileProjectServices.fetchProjects();

		if (res.error) {
		} else {
			//if (res.data.length == 0) {
				//fetchPosts();
			//} else {
				fetchProjects(res.data);
				setDataFetched(true);
			//}
		}
	}

	return (
		<>
			<CLoader condition={dataFetched} />

			<ProjectsLayout>
				<SEO title="Portfolio" />

				<main className="projects-page">
					<ProjectsSection />

					{/* <Footer /> */}
				</main>
			</ProjectsLayout>
		</>
	);
};

export default IndexPage;
